import React from "react";
import "./index.scss";

interface NotFoundResultProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  extra?: React.ReactNode[];
}

const NotFoundResult: React.FC<NotFoundResultProps> = (props) => {
  const {
    title = "404",
    subtitle = "Whoops, that page is gone.",
    extra = [],
  } = props;

  return (
    <div className="yf-not-found-result">
      <p className="yf-not-found-result-tip">{title}</p>
      <p className="yf-not-found-result-subtitle">{subtitle}</p>
      {extra?.length > 0 && (
        <div className={"yf-not-found-result-extra"}>
          {extra?.map((dom) => dom)}
        </div>
      )}
    </div>
  );
};

export default NotFoundResult;
